(ns teamoesterreich.admin-mode.administration.help.help-admin-list
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.webHelpText :as d-webHelpText]
            [teamoesterreich.admin-mode.actions :as a]


            [reagent-material-ui.icons.build :refer [build]]

            ))



(defn time-conv [rest-time]
  (if (= "" (str rest-time))
    nil
    (js/Date. (str (subs rest-time 0 4) "-" (subs rest-time 4 6) "-" (subs rest-time 6 11) ":" (subs rest-time 11 13) ":" (subs rest-time 13 19) "-00:00"))))

(defn time-print [rest-time]
  (if (= "" (str rest-time))
    nil
    (let [d (time-conv rest-time)] (str (.toLocaleDateString d) " " (subs (.toLocaleTimeString d) 0 5)))))




(defn help-block-card [text !opened]
  (let [allowEdit? (d-rights/allow-admin-for d-rights/CONTENT)]
    [mui/card {:style {:backgroundColor (if (get text :webHelpText-published) "" "#e6e6e5") :marginBottom "20px"}}
     [mui/card-header
      {:title
       (r/as-element [mui/grid
                      {:container  true
                       :direction  "row"
                       :alignItems "stretch"
                       :justify    "flex-start"
                       }
                      [mui/grid
                       {:item  true
                        :md    2
                        :xs    12
                        :style {:height "80px" :textAlign "left" :paddingLeft ""}
                        }
                       [:span {:style {:fontSize "14px"}} (time-print (get text :webHelpText-date))]
                       ]

                      [mui/grid
                       {:item  true
                        :md    8
                        :xs    12
                        :style {:height "80px" :textAlign "left" :paddingLeft "20px"}
                        }
                       [mui/typography {:variant "h5"} (str (get text :webHelpText-title))]]

                      [mui/grid
                       {:item  true
                        :md    2
                        :xs    12
                        :style {:height "80px" :textAlign "left" :paddingLeft ""}
                        }
                       [:span {:style {:fontSize "14px"}} (when-not (get text :webHelpText-published) "[unveröffentlicht]")]
                       ]]
                     )}]

     [mui/card-actions
      (when allowEdit?
        [mui/button {:startIcon (r/as-element [build])
                     :onClick   (fn []
                                  (reset! !opened (get text :webHelpText-uuid))
                                  (a/set-page :help-admin))
                     }
         "Bearbeiten"
         ])
      ]

     ]))

(defn get-it []
  (let [!webHelpText-list (r/atom {:loaded false :data {} :opened nil})
        !loaded (r/cursor !webHelpText-list [:loaded])
        !data (r/cursor !webHelpText-list [:data])
        !opened (r/cursor vstate/app-state [:webHelpText-list :opened])
        reload-fn #(reset! !loaded false)]
    (fn []
      (if-not @!loaded
        (do
          (d-webHelpText/get-list
            (fn [response]
              (swap! !webHelpText-list assoc :loaded true :data response)))
          [mui/paper
           [:br]
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [mui/typography {} "Lade Daten ... "]
           ]
          )
        (do

          [mui/grid
           {:container  true
            :direction  "row"
            :alignItems "stretch"
            :justify    "flex-start"
            :style      {:textAlign "left"}
            }
           [mui/grid
            {:item  true
             :xs    12
             :style {:height "50px"}
             }
            [mui/typography {:variant "h5" :style {:margin "12px 0 0 400px"}
                             :onClick reload-fn}
             "Online Hilfetexte"]]


           (for [[uuid text] (sort-by (fn [[uuid n]] (:webHelpText-rank n)) @!data)]
             ^{:key (str "webHelpText-" uuid)}
             [mui/grid
              {:container false
               :item      true
               :xl        7
               :xs        12                                ;extra-small: 0px
               }
              [help-block-card text !opened]
              ]
             )
           ]

          ))

      )))

